import {combineReducers} from '@reduxjs/toolkit';
import {
    userEmailDeliveryLogStateSlice,
} from 'src/modules/profile/user/tabs/user-login/email-history/slices/user-email-delivery-log-state.slice';
import {
    userEmailDeliveryLogSlice,
} from 'src/modules/profile/user/tabs/user-login/email-history/slices/user-email-delivery-log.slice';

export const userEmailDeliveryLogReducer = combineReducers({
    events: userEmailDeliveryLogSlice.reducer,
    state: userEmailDeliveryLogStateSlice.reducer,
});
